<template>
  <svg width="9" height="12" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.857143 3.5V2.5C0.857143 1.83696 1.08291 1.20107 1.48477 0.732233C1.88663 0.263392 2.43168 0 3 0C3.56832 0 4.11337 0.263392 4.51523 0.732233C4.91709 1.20107 5.14286 1.83696 5.14286 2.5V3.5C5.37019 3.5 5.5882 3.60536 5.74895 3.79289C5.90969 3.98043 6 4.23478 6 4.5V7C6 7.26522 5.90969 7.51957 5.74895 7.70711C5.5882 7.89464 5.37019 8 5.14286 8H0.857143C0.629814 8 0.411797 7.89464 0.251051 7.70711C0.0903058 7.51957 0 7.26522 0 7V4.5C0 4.23478 0.0903058 3.98043 0.251051 3.79289C0.411797 3.60536 0.629814 3.5 0.857143 3.5ZM4.28571 2.5V3.5H1.71429V2.5C1.71429 2.10218 1.84974 1.72064 2.09086 1.43934C2.33198 1.15804 2.65901 1 3 1C3.34099 1 3.66802 1.15804 3.90914 1.43934C4.15026 1.72064 4.28571 2.10218 4.28571 2.5Z"
      fill="#ec1b0e"
    />
  </svg>
</template>

<script>
export default {
  name: 'Blocked',
}
</script>

<style scoped></style>
